import React, {useEffect, useState} from 'react';
import axios from "axios";
import { appConfig } from "./../../tools/AppConfig";
import { dependencies } from '../../tools/Dependencies';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import flags from 'react-phone-number-input/flags'
import Waiting from './../../modules/waiting';
import SimpleHeader from './../../modules/simpleHeader_new';
import Message from './../errors/message';
import poweredByPaymob from './../../../statics/img/powered-by-paymob.png';
import checkout_button from "../../../statics/img/payment_links/button.png";
import './payment_links.css';
const CLIENT_EMAIL_PLACEHOLDER = 'na@na.com';


export default function PaymentLinks(){

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token') || urlParams.get('multiple_token');
    const tokenParam = urlParams.has('token') ? 'token=' + token : 'multiple_token=' + token;

    const [waiting, setWaiting] = useState(true);
    const [userData, setUserData] = useState({phoneNumber:"", email:"", fullName:""});
    const [nameValidation, setNameValidation] = useState(true);
    const [phoneNumberValidation, setPhoneNumberValidation] = useState(true);
    const [emailValidation, setEmailValidation] = useState(true);
    const [requestComplete, setRequestComplete] = useState(false);
 
    const [order, setOrder] = useState({
        business_information: {
        }
    });

    const loadData = () => {
        setWaiting(true);
        let invoiceUrl = `${appConfig.getServerUrl()}/api/ecommerce/payment-links/unrestricted?${tokenParam}`;
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        axios.get(
            invoiceUrl,
            config
        )
        .then((resp)=>{
            if(resp.data.expired){
                setReqComplete({head: 'Oops! looks like this payment link is expired.', body:'Please contact the seller for a new link.'});
            }else if(resp.data.deactivated){
                setReqComplete({head: 'Oops! looks like this payment link is deactivated.', body:'Please contact the seller for a new link.'});
            }else if(resp.data.paid){
                setReqComplete({head: 'Oops! looks like this payment link is paid.', body:'Please contact the seller for a new link.'});
            }else{
                setOrder(resp.data);
            }
            setWaiting(false);
        })
        .catch((err)=>{
            // 404 Order not found
            // 422 Merchant not onboarded
            // 406 Order expired
            // 429 Request throttled
          setReqComplete({head: 'Connection error', body:'Oops! Something went wrong. If this problem persists, please contact your service provider.'});
          setWaiting(false);
        });
    }
    const setReqComplete = (Message) => {
        setRequestComplete({requestComplete: true, completeMessage: Message, waiting: false});
    }
    const RenderComplete = () => {
        return(
            <div class="newStandalone">
                <div className="invoice">
                    <SimpleHeader />
                    <div className="standaloneBody">
                    <Message head={requestComplete.completeMessage.head} body={requestComplete.completeMessage.body}  />
                    </div>
                </div>
            </div>
        )
    }
    useEffect(() => {
        loadData();
    }, []);
    function formatCents(cents) {
        let dollars = cents / 100;
        return dollars.toLocaleString('en-US', {style: 'decimal', minimumFractionDigits: 2});
    }
    function isValidName(name) {
        const trimmedName = name.trim();
        const regex = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDCF\uFDF0-\uFDFF\uFE70-\uFEFFa-zA-Z]+( [\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDCF\uFDF0-\uFDFF\uFE70-\uFEFFa-zA-Z]+)*$/;
        return regex.test(trimmedName) && trimmedName.length <= 30;
    }
    function isValidEmail(email) {
        // Regular expression pattern for email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      
        // Test the email against the regular expression
        return emailRegex.test(email);
    }
      
    function isValidPhoneNumber(phoneNumber) {
        // Remove anything that is not a digit or a '+' sign
        phoneNumber = phoneNumber.replace(/[^+\d]/g, '');
        
        // Remove the '+' before checking
        const phone = phoneNumber.startsWith('+') ? phoneNumber.slice(1) : phoneNumber;
        
        // Do not allow phone numbers to start with '01'
        if (phone.startsWith('01') || phone.startsWith('+01')) {
            return false;
        }
        
        const regex = /^\d{1,15}$/; // Allow 1 to 15 digits
        
        // Create a mapping of country codes to phone number length
        // For Pakistan, allowing a range: minimum and maximum length
        const countryCodes = {
            '20': 12,
            '966': 12,
            '92': [10, 14], // Updated for Pakistan
            '971': 12,
            '968': 12,
        };
        
        for (let countryCode in countryCodes) {
            if (phone.startsWith(countryCode)) {
                const length = countryCodes[countryCode];
                let remainingLength, minLength, maxLength;
                
                if (Array.isArray(length)) {
                    [minLength, maxLength] = length;
                    const countryRegex = new RegExp(`^${countryCode}\\d{${minLength - countryCode.length},${maxLength - countryCode.length}}$`);
                    
                    return countryRegex.test(phone);
                } else {
                    remainingLength = length - countryCode.length;
                    
                    // Check if the country is Saudi Arabia or UAE
                    if (countryCode === '966' || countryCode === '971') {
                        const countryRegex = new RegExp(`^${countryCode}(5\\d{${remainingLength - 1}})$`);
                        
                        return countryRegex.test(phone);
                    } else {
                        const countryRegex = new RegExp(`^${countryCode}\\d{${remainingLength}}$`);
                        
                        return countryRegex.test(phone);
                    }
                }
            }
        }
        
        // If country code is not found, validate with the general pattern
        return regex.test(phone);
    }
      
    const handleSubmit = (e) => {
        e.preventDefault();
        isValidPhoneNumber(userData.phoneNumber) ? setPhoneNumberValidation(true) : setPhoneNumberValidation(false);
        if(!order.client_info){
            if(isValidPhoneNumber(userData.phoneNumber) && nameValidation){
                setWaiting(true);
                let updateUrl = appConfig.getServerUrl() + "/api/ecommerce/payment-links/update-client-data";
                let requestBody;
                if(urlParams.get('token')){
                    requestBody={
                        "token": token,
                        "full_name": userData.fullName,
                        "phone_number": userData.phoneNumber,
                        "email": userData.email
                    }
                }else if(urlParams.get('multiple_token')){
                    requestBody={
                        "attempt_token" : order.attempt ,
                        "multiple_token": token,
                        "full_name": userData.fullName,
                        "phone_number": userData.phoneNumber,
                        "email": userData.email
                    }   
                }
                axios.put(updateUrl,requestBody).then( async (response)=>{
                    const attemptParam = `attempt_token=${response.data.attempt}`;
                    const invoiceUrl = `${appConfig.getServerUrl()}/api/ecommerce/payment-links/unrestricted?${tokenParam}&${attemptParam}`;
                    let config = {
                        headers: {
                            "Content-Type": "application/json",
                            "Accept": "application/json"
                        }
                    };
                    axios.get(
                        invoiceUrl,
                        config
                    )
                    .then((resp)=>{
                        if(resp.data.expired === true){
                            setReqComplete({head: 'Connection error', body:'Oops! Something went wrong. If this problem persists, please contact your service provider.'});
                        }
                        else{
                            window.location.href = `${appConfig.getServerUrl()}/unifiedcheckout/?publicKey=${resp.data.public_key}&clientSecret=${resp.data.client_secret}`;
                        }
                    })
                    .catch((err)=>{
                        // 404 Order not found
                        // 422 Merchant not onboarded
                        // 406 Order expired
                        // 429 Request throttled
                        setReqComplete({head: 'Connection error', body:'Oops! Something went wrong. If this problem persists, please contact your service provider.'});
                    });
                }).catch((err)=>{
                    setReqComplete({head: 'Connection error', body:'Oops! Something went wrong. If this problem persists, please contact your service provider.'});
                    setWaiting(false);
                })
            }
        }else{
            window.location.href = `${appConfig.getServerUrl()}/unifiedcheckout/?publicKey=${order.public_key}&clientSecret=${order.client_secret}`;
        }
    }

    useEffect(() => {
        if(isValidName(userData.fullName) || userData.fullName === ""){
            setNameValidation(true);
        }
        else{
            setNameValidation(false);
        }
    }, [userData.fullName]);

    useEffect(() => {
        if(isValidEmail(userData.email) || userData.email === ""){
            setEmailValidation(true);
        }
        else{
            setEmailValidation(false);
        }
    }, [userData.email]);

    useEffect(() => {
        if(isValidPhoneNumber(userData.phoneNumber) || userData.phoneNumber === ""){
            setPhoneNumberValidation(true);
        }
        else{
            setPhoneNumberValidation(false);
        }
    }, [userData.phoneNumber]);

    const renderBody = () => (
        <main className='payment-links-main'>
            <div className="payment_links_container">
                <header className="payment_links_header">
                    {(order.business_information && order['business_information'].logo_image) &&
                        <img className="payment_links_merchant_logo" src={order['business_information'].logo_image} alt="merchant logo"/>
                    }
                    {order.business_information && <h2 className="payment_links_merchant_name">{order['business_information'].brand_name}</h2>} 
                    {order["business_information"] && 
                        <span className="payment_links_social">
                            {order['business_information'].facebook_url &&<a href={order["business_information"].facebook_url.startsWith('https') ? order["business_information"].facebook_url : `https://${order["business_information"].facebook_url}`} target="_blank"><i className="fa fa-facebook" aria-hidden="true"></i></a>} 
                            {order['business_information'].instagram_url &&<a href ={order["business_information"].instagram_url.startsWith('https') ? order["business_information"].instagram_url : `https://${order["business_information"].instagram_url}`} target="_blank"><i className="fa fa-instagram" aria-hidden="true"></i></a>}
                            {order['business_information'].whatsapp_number && <a href={`https://wa.me/${order["business_information"].whatsapp_number}`} target="_blank"><i className="fa fa-whatsapp" aria-hidden="true"></i></a>}
                            {order['business_information'].website_url &&  <a href={order.business_information && order["business_information"].website_url} target="_blank"><i className="fa fa-globe" aria-hidden="true"></i></a>}
                        </span>
                    }
                </header>
                <section className="payment_links_details">
                    <div className="payment_links_left">
                        <p>Pay {order.business_information && order['business_information'].brand_name}</p>
                        <h3 className="payment_links_price">{`${order.currency} ${formatCents(order.amount_cents)}`}</h3>
                        <p className="payment_links_details_description">{order.description}</p>
                    </div>
                    <div className="payment_links_right">
                        {order.payment_link_image&&<img className="payment_links_product_image" src={order.payment_link_image} alt="product"/>}
                    </div>
                </section>
                <form onSubmit={handleSubmit}>
                    <section className="payment_links_customer_information">
                        <h3 className="payment_links_customer_information_title">Customer Information</h3><br/>
                        {order.client_info ?
                            <>
                                <div className="payment_links_customer_information_left">
                                    <span className='payment_links_light_text'>Full Name </span><br/>
                                    { order.client_info.email && order.client_info.email.toLowerCase() !== CLIENT_EMAIL_PLACEHOLDER && (
                                        <>
                                            <span className="payment_links_light_text">Email </span>
                                            <br />
                                        </>
                                    )}
                                    <span className='payment_links_light_text'>Phone Number </span><br/>
                                </div>
                                <div className="payment_links_customer_information_right">
                                    <span className='payment_links_dark_text'>{order.client_info.full_name}</span><br/>
                                    { order.client_info.email && order.client_info.email.toLowerCase() !== CLIENT_EMAIL_PLACEHOLDER && (
                                        <>
                                            <span className="payment_links_dark_text">{order.client_info.email} </span>
                                            <br />
                                        </>
                                    )}                                   
                                    <span className='payment_links_dark_text'>{order.client_info.phone_number}</span>
                                </div> 
                            </>
                        :
                            <>     
                                <span className='payment_links_light_text'>Full Name </span>
                                <br/>
                                <input className="payment_links_input" type="text" name="full_name" id="full_name" placeholder="Ex: Yahia Ali"  onChange={ e=> setUserData({ ...userData, fullName:e.target.value })} required />
                                <br/>
                                {!nameValidation && <span className="error">{userData.fullName.length> 30?"name shall not exceed 30 character":"invalid name"}<br/></span>}
                                <br/>
                                <span className='payment_links_light_text'>Email </span>
                                <br/>
                                <input 
                                    className="payment_links_input"
                                    type="email"
                                    name="email"
                                    id="email"
                                    placeholder="Yahia@example.com"
                                    onChange={e => setUserData({ ...userData, email:e.target.value })} 
                                    required
                                />
                                <br/>
                                {!emailValidation && <span className="error">Kindly add a valid email<br/></span>}
                                <br/>
                                <span className='payment_links_light_text'>Phone Number </span>
                                <br/>
                                <br/>
                                <PhoneInput
                                    value={userData.phoneNumber === "" ? null : userData.phoneNumber}
                                    onChange={phone => setUserData({ ...userData, phoneNumber: phone ? phone : "" })}
                                    style={{width:"300px", maxWidth:"100%", background:"white"}}
                                    className="payment_links_phone_input"
                                    flags={flags}
                                    defaultCountry={dependencies.getCountryFromDomain()}
                                    withCountryCallingCode={false}
                                    international={true}
                                    inputProps={{
                                        name: 'phone',
                                        required: true,
                                        autoFocus: false
                                    }}
                                />
                                <br/>
                                {!phoneNumberValidation &&<span className="error">Kindly add a valid phone number</span>}
                            </>
                        }
                    </section>
                    <div className="payment_links_submit_container">   
                        <button className="payment_links_checkout_button" type="submit">
                            <img src={checkout_button} alt="checkout with paymob"/>
                        </button>
                    </div>
                </form>
                <footer className='payment_links_footer'>
                    <img src={poweredByPaymob} alt="Powered By Paymob"/>
                </footer>
            </div>
        </main>
    )
    
    return (
        waiting ? 
            <Waiting/>
        :
            requestComplete.requestComplete?
                <RenderComplete/>
            :
                renderBody()
    )
}